import { render, staticRenderFns } from "./LPCATTest.vue?vue&type=template&id=9ccf6d8e&scoped=true&"
import script from "./LPCATTest.vue?vue&type=script&lang=js&"
export * from "./LPCATTest.vue?vue&type=script&lang=js&"
import style0 from "./LPCATTest.vue?vue&type=style&index=0&id=9ccf6d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccf6d8e",
  null
  
)

export default component.exports